import React, { Fragment } from 'react';
import './CertificateCard.css';
import Button from '../../../buttons/Button';
import UdemyLogo from './UdemyLogo';
import { Fade, Flip } from 'react-reveal';

const CertificateCard = () => {
  return (
    <Fragment>
      <div className='degree-card'>
        <Flip left duration={2000}>
          <div className='card-img'>
            <img
              className='certificate-pic'
              src={require('../../../../../img/zuitt-logo.png')}
              alt='lupet'
            />
          </div>
        </Flip>
        <Fade duration={2000} distance='40px'>
          <div className='card-body'>
            <div className='body-header'>
              <div className='body-header-title'>
                <h2 className='card-title'>Zuitt Coding Bootcamp</h2>
                <h3 className='card-subtitle'>Full Stack Web Development</h3>
              </div>
              <div className='body-header-duration'>
                <h3 className='duration'>April 2019 - July 2019</h3>
              </div>
            </div>
            <div classname='body-content'>
              <p className='content-list'>
                <span role='img' aria-label='thunder'>
                  ⚡
                </span>{' '}
                Full-stack Web Development Training using HTML, CSS, MySQL
                (MariaDB fork), JavaScript (ES6+), JQuery, Bootstrap, SASS, PHP,
                Laravel, MongoDB, Heroku, Node JS, React JS and Express JS for 3
                months worth of intensive training.
              </p>
              <a
                href='https://www.linkedin.com/in/ojrmorales/detail/treasury/education:602821288/?entityUrn=urn%3Ali%3Afsd_profileTreasuryMedia%3A(ACoAACzImKkBFkq50dK63IkE_8lpokXRABykUlg%2C1564504306410)&section=education%3A602821288&treasuryCount=2'
                target='_blank'
                rel='noopener noreferrer'
              >
                <div className='visit-btn'>
                  <Button
                    style={{ marginTop: '0px' }}
                    text='Check Certificate'
                    newTab={true}
                  />
                </div>
              </a>
            </div>
          </div>
        </Fade>
      </div>
      <div className='degree-card'>
        <Flip left duration={2000}>
          <div className='card-img'>
            <UdemyLogo />
          </div>
        </Flip>
        <Fade duration={2000} distance='40px'>
          <div className='card-body'>
            <div className='body-header'>
              <div className='body-header-title'>
                <h2 className='card-title'>
                  MERN Stack Front To Back: Full Stack React, Redux &amp;
                  Node.js by Brad Traversy
                </h2>
                <h3 className='card-subtitle'>
                  Build and deploy a social network with Node.js, Express,
                  React, Redux &amp; MongoDB. Fully
                </h3>
              </div>
              <div className='body-header-duration'>
                <h3 className='duration'>July 2020</h3>
              </div>
            </div>
            <div classname='body-content'>
              <p className='content-list'>
                <span role='img' aria-label='thunder'>
                  ⚡
                </span>{' '}
                Built a full stack social network app with React, Redux, Node,
                Express &amp; MongoDB
              </p>
              <p className='content-list'>
                <span role='img' aria-label='thunder'>
                  ⚡
                </span>{' '}
                Create an extensive backend API with Express
              </p>
              <p className='content-list'>
                <span role='img' aria-label='thunder'>
                  ⚡
                </span>{' '}
                Integrate React with an Express backend in an elegant way
              </p>
              <p className='content-list'>
                <span role='img' aria-label='thunder'>
                  ⚡
                </span>{' '}
                Use Redux for state management
              </p>
              <p className='content-list'>
                <span role='img' aria-label='thunder'>
                  ⚡
                </span>{' '}
                Used Stateless JWT authentication practices
              </p>
              <p className='content-list'>
                <span role='img' aria-label='thunder'>
                  ⚡
                </span>{' '}
                React Hooks, Async/Await &amp; modern practices
              </p>
              <p className='content-list'>
                <span role='img' aria-label='thunder'>
                  ⚡
                </span>{' '}
                Deploy to Heroku with a postbuild script
              </p>
              <a
                href='https://drive.google.com/file/d/1vtQ7IsOdnUwjLV9DtbXx5Bjryl9b0lQX/view?usp=sharing'
                target='_blank'
                rel='noopener noreferrer'
              >
                <div className='visit-btn'>
                  <Button
                    style={{ marginTop: '0px' }}
                    text='Check Certificate'
                    newTab={true}
                  />
                </div>
              </a>
            </div>
          </div>
        </Fade>
      </div>
    </Fragment>
  );
};

export default CertificateCard;
